import {
  Autocomplete,
  Box,
  Button,
  Grid,
  MenuItem,
  Modal,
  Select,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import * as posenet from "@tensorflow-models/posenet";
import * as tf from "@tensorflow/tfjs";
import Cookies from "js-cookie";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Webcam from "react-webcam";
import Navbar from "../../components/AppBar/Navbar";
import Service from "../../services/httpService";
import { Color } from "../../../GlobalStyles";
import FiberNewOutlinedIcon from "@mui/icons-material/FiberNewOutlined";
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import { roleHeadingsData } from "../../common/constants";

function AssessmentTest() {
  const services = new Service();
  const webcamRef = useRef(null);
  const navigate = useNavigate(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const query_test_id = queryParams.get("test_id");
  const query_test_type = queryParams.get("test_type_id");
  const fr = queryParams.get("fr"); //Face recogniazion in query
  const query_role = queryParams.get("role_id"); //Face recogniazion in query

  const [modal, setModal] = useState(false);
  const [testLoader, setTestLoader] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [modalIndex, setModalIndex] = useState(0);
  const [testTypes, setTestTypes] = useState([]);
  const [onGoingTest, setOngoingTest] = useState([]);
  const [completedTest, setCompletedTest] = useState([]);
  const [tests, setTests] = useState([]);
  const [selectedTest, setSelectedTest] = useState(null);
  const [selectedRoles, setSelectedRoles] = useState(null);
  const [selectedSpecialization, setSelectedSpecialization] = useState(null);
  const [allRoles, setAllRoles] = useState([]);
  const [sjtRoles, setsJtRoles] = useState([]);
  const [showAlt, setShowAlt] = useState(false);
  const [allSpecializations, setAllSpecializations] = useState([]);
  const [selectedRolePrepardness, setSelectedRolePrepardness] =
    useState("Role");
  const [inputValue, setInputValue] = useState("");
  const [faceError, setFaceError] = useState("");
  const [cameraError, setCameraError] = useState("");
  // console.log("test", tests)
  console.log("modalIndex", modalIndex)
  const handleTestTypeSelection = index => {
    let temp_test_type = testTypes.map((item, test_index) => {
      if (test_index === index) {
        return {
          ...item,
          selected: true,
        };
      } else {
        return {
          ...item,
          selected: false,
        };
      }
    });
    if (testTypes[index].test_sections !== null) {
      setSelectedRoles(testTypes[index].test_sections[0]);
    }
    setTestTypes(temp_test_type);
  };

  const handleTestSelection = (item, type) => {
    if (type === "unAttempted") {
      let selected_test = tests.find(
        (test, t_index) => test.test_id === item.test_id
      );

      setSelectedTest(selected_test);
      setModal(true);
    } else {
      let selected_test = onGoingTest.find(
        (test, t_index) => test.test_id === item.test_id
      );
      console.log("SelectedTest", selected_test);
      setSelectedTest(selected_test);
      setModal(true);
    }
  };
  const handleRoleSelect = e => {
    if (selectedRolePrepardness === "Role") {
      setSelectedRoles(e.target.value);
    } else {
      setSelectedSpecialization(e.target.value);
    }
  };

  const handleCEE = () => {
    window.parent.postMessage(
      { type: "NAVIGATE", path: "/Dashboard/Employability" },
      process.env.REACT_FRONTEND_URL // parent origin
    );
  }

  useEffect(() => {
    const getTestData = async () => {
      setTestLoader(true);
      const token = Cookies.get("token");
      // if ([null, undefined, ""].includes(token)) {
      //   navigate("/");
      //   return;
      // }
      const allTests = await services.get("/tests/getTestType");
      const allRoles = await services.get("/superAdmin/role");
      const allSpecialization = await services.get(
        "/superAdmin/specialization"
      );

      const temp_sjtRoles = await services.get(
        "/jobs/rolesByTestTypeId?test_type_id=5"
      );

      setAllRoles(allRoles.data);
      setsJtRoles(temp_sjtRoles.data);
      setSelectedRoles(allRoles.data[0]);
      setAllSpecializations(allSpecialization.data);
      setSelectedSpecialization(allSpecialization.data[0]);
      console.log("QUERY TEST TYPE", query_test_type);
      let temp_test_types = allTests.data.map((item, index) => {
        if (
          [null, undefined, "", "null", "undefined"].includes(query_test_type)
        ) {
          return {
            ...item,
            selected: index === 1 ? true : false,
          };
        } else {
          if (parseInt(query_test_type) === item.test_type_id) {
            const test_Section =
              item.test_sections !== null
                ? JSON.parse(item.test_sections).sections
                : null;
            if (test_Section !== null) {
              let id = test_Section.find(ele =>
                ele.test_ids.split(",").includes(query_test_id)
              );

              console.log("fldkjslfjldsjflsd", test_Section, id);

              setSelectedRoles(id ? id : test_Section[0]);
            }
          }
          return {
            ...item,
            selected:
              parseInt(query_test_type) === item.test_type_id ? true : false,
          };
        }
      });

      [temp_test_types[0], temp_test_types[1]] = [
        temp_test_types[1],
        temp_test_types[0],
      ];

      temp_test_types = temp_test_types.map(item => {
        return {
          ...item,
          test_sections:
            item.test_sections === null
              ? null
              : JSON.parse(item.test_sections).sections,
        };
      });
      setTestTypes(temp_test_types);

      if (![null, undefined, ""].includes(query_role)) {
        setTestLoader(true);
        const questions = await services.get(
          `/jobs/assessmentByRoleId?role_id=${query_role}&test_type_id=${query_test_type}`
        );

        let temp_role = allRoles.data.find(
          item => item.id === parseInt(query_role)
        );
        setSelectedRoles(temp_role);

        if (questions.success) {
          setTests(questions.pending_tests[0].test_not_attempted);
          setCompletedTest(manipulateCompletedTest(questions.testDone));
          setOngoingTest(questions.pending_tests[0].ongoingTests);

          if (![null, undefined, ""].includes(query_test_id)) {
            let selected_test =
              questions.pendingTests[0].test_not_attempted.find(
                (test, t_index) => test.test_id === parseInt(query_test_id)
              );
            setSelectedTest(selected_test);
            setModal(true);
          }
          setTestLoader(false);
        }
      }

      if ([true, "true"].includes(fr) && query_test_type !== 1) {
        setTestLoader(true);

        const questions = await services.get(
          `/tests/getAllTestByTestType?test_type_id=${query_test_type}`
        );

        if (questions.success) {
          let selected_test = questions.pendingTests[0].test_not_attempted.find(
            (test, t_index) => test.test_id === parseInt(query_test_id)
          );
          console.log("Selected test", selected_test, typeof query_test_id);
          setSelectedTest(selected_test);
          setModal(true);
          setTests(questions.pendingTests[0].test_not_attempted);
          setCompletedTest(manipulateCompletedTest(questions.testsDone));
          setOngoingTest(questions.pendingTests[0].ongoingTests);
          setTestLoader(false);
        }
      }
    };

    getTestData();
  }, []);

  const manipulateCompletedTest = data => {
    let test = data.map((item, index) => {
      let testDetails =
        typeof item.test_detail === "string"
          ? JSON.parse(item.test_detail)
          : item.test_detail;
      return {
        test_name: item.test_name,
        test_id: item.test_id,
        count_correct_response:
          typeof testDetails.count_correct_response === "string"
            ? JSON.parse(testDetails.count_correct_response)
            : testDetails.count_correct_response,
        mxm_marks: testDetails.mxm_marks,
        percentile: testDetails.percentile,
        score: testDetails.score.toFixed(2),
        no_of_test_given: testDetails.test_taken_by
      };
    });
    console.log("TEDTDONE", test);
    return test;
  };

  useEffect(() => {
    const getTestData = async () => {
      setTestLoader(true);
      let selected_test_type = testTypes.find(t => t.selected === true);
      if (testTypes.length > 0) {
        if (selected_test_type.test_sections !== null) {
          // const questions = await services.get(
          //   `/jobs/assessmentByRoleId?role_id=${selectedRoles.id}&test_type_id=${selected_test_type.test_type_id}`
          // );

          const questions = await services.get(
            `/tests/getTest/section?test_ids=${selectedRoles.test_ids}`
          );

          console.log("Selected Role", questions);
          setTests(questions.pendingTests[0].test_not_attempted);
          setCompletedTest(manipulateCompletedTest(questions.testsDone));
          setOngoingTest(questions.pendingTests[0].ongoingTests);
          setTestLoader(false);
        } else {
          const questions = await services.get(
            `/tests/getAllTestByTestType?test_type_id=${selected_test_type.test_type_id}`
          );

          setTests(questions.pendingTests[0].test_not_attempted);
          setCompletedTest(manipulateCompletedTest(questions.testsDone));
          setOngoingTest(questions.pendingTests[0].ongoingTests);
          setTestLoader(false);
        }
      }
    };

    getTestData();
  }, [
    testTypes,
    selectedRoles,
    selectedSpecialization,
    selectedRolePrepardness,
  ]);

  const handleCameraAccess = async () => {
    console.log("camera access called");
    setCameraError(""); // Clear previous errors
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });
      if (stream.active) {
        setModalIndex(1);
      }
    } catch (error) {
      console.error("Error accessing media devices:", error);
      setCameraError(
        "Could not access camera. Please explicitly allow permissions in your browser settings and try again."
      );
    }
  };

  useEffect(() => {
    if (modal && modalIndex === 0) {
      handleCameraAccess();
    }
  }, [modal, modalIndex]);

  useEffect(() => {
    const runPoseEstimation = async () => {
      if (buttonDisabled) {
        tf.setBackend("webgl");
        const net = await posenet.load({
          architecture: "ResNet50",
          outputStride: 16,
          inputResolution: { width: 100, height: 100 },
          quantBytes: 2,
        });
        const webcam = webcamRef.current.video;
        // const pose = await net.estimateSinglePose(webcam, {
        //   flipHorizontal: true,
        // });

        const multiplePose = await net.estimateMultiplePoses(webcam, {
          flipHorizontal: true,
          outputStride: 16,
          maxDetections: 2,
          scoreThreshold: 0.0,
        });
        console.log("POSE", multiplePose);
        let count = 0;
        multiplePose.map(person => {
          if (
            person.score > 0.35 ||
            (person.keypoints[0].score > 0.5 &&
              person.keypoints[1].score > 0.5 &&
              person.keypoints[2].score > 0.5 &&
              person.score > 0.2)
          ) {
            count = count + 1;
          }
        });

        if (count > 1) {
          setFaceError(
            "Multiple individuals Detected, ensuring compliance with the instruction for a singular person at a time."
          );
        } else if (count === 0) {
          setFaceError(
            "No face detected. To start the test please ensure your webcam is on and facing you directly."
          );
        } else {
          setButtonDisabled(false);
          setFaceError("");
        }

        // eslint-disable-next-line no-undef
        tf.dispose(multiplePose);
        tf.dispose(net);
        // eslint-disable-next-line no-unused-expressions
        tf.memory().numTensors; // Check the number of tensors (optional)
        tf.memory().dispose();

        // Check if a key body part (e.g., nose, eyes) is within a certain position range
        // if (
        //   pose.keypoints[0].score < 0.7 ||
        //   pose.keypoints[1].score < 0.8 ||
        //   pose.keypoints[2].score < 0.8
        // ) {
        //   // User may not be sitting in front of the camera
        //   console.log("User is not sitting in front of the camera.");
        //   window.alert("User is not sitting in front of the camera.");
        // } else {
        //   // User is sitting in front of the camera
        //   console.log("User is sitting in front of the camera.");
        //   setButtonDisabled(false);
        // }
      }
    };
    if (modal) {
      const intervalId = setInterval(runPoseEstimation, 5000);

      return () => {
        clearInterval(intervalId);
      };
    }
  }, [modalIndex, buttonDisabled, modal]);


  useEffect(() => {
    const timer = setInterval(() => setShowAlt(prev => !prev), 10000); // 10 sec switch
    return () => clearInterval(timer);
  }, []);

  const formatTestTakersRange = (testTakers) => {
    if (testTakers >= 100 && testTakers < 1000) {
      const rounded = Math.floor(testTakers / 100) * 100;
      return `${rounded}+`;
    }
    return null;
  };


  const bgImages = [
    "https://du03hetco8xdw.cloudfront.net/assessment/business-analytics-banner.png",
    "https://du03hetco8xdw.cloudfront.net/assessment/data-scientist-banner.png",
    "https://du03hetco8xdw.cloudfront.net/assessment/data-visualization-banner.png",
    "https://du03hetco8xdw.cloudfront.net/assessment/finance-analytics-banner.png",
    "https://du03hetco8xdw.cloudfront.net/assessment/live-project-banner.png",
    "https://du03hetco8xdw.cloudfront.net/assessment/logical-ability-banner.png",
    "https://du03hetco8xdw.cloudfront.net/assessment/sector-awareness-banner.png",
    "https://du03hetco8xdw.cloudfront.net/assessment/situational-judgement-banner.png",
    "https://du03hetco8xdw.cloudfront.net/assessment/verbal-ability-banner.png"
  ]



  const selectedTestType = testTypes?.find((t) => t.selected);
  const randomBgImage = useMemo(() => bgImages[Math.floor(Math.random() * bgImages.length)], [selectedTestType, selectedRoles, showAlt]);

  const headline = showAlt ? "Not sure where to begin?" : "Are you taking the right test… or practicing aimlessly?";
  const subText = showAlt ? "The CEE exam helps you discover your fit, take the right test, and prepare with purpose." : "Smart prep beats hard prep; Take CEE Exam— discover your fit, take the right test, and stand out.";

  const bannerData = {
    headText: selectedTestType?.test_type_id == "1" ? roleHeadingsData.find((t) => t.label == selectedRoles?.section_name)?.content.headline : headline,
    subText: selectedTestType?.test_type_id == "1" ? roleHeadingsData.find((t) => t.label == selectedRoles?.section_name)?.content.subText : subText,
  }
  return (
    <Box>
      {/* <SideNavBarStudent /> */}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          width: "98%",
          margin: "auto",
          paddingBlock: "0rem",
        }}
      >
        {/* <Box>
          <Navbar
            title="Assessment Tests"
            description=" Select the category of tests you would like to take"
          />
        </Box> */}
        {/* <Box
          sx={{ cursor: "pointer" }}
          onClick={() => window.open("https://www.careercarve.com", "_blank")}
        >
          <picture>
            <source
              media="(min-width: 1024px)"
              srcSet="https://du03hetco8xdw.cloudfront.net/RD_landing_page/webTestsBanner.jpg"
            />
            <source
              media="(min-width: 768px)"
              srcSet="https://du03hetco8xdw.cloudfront.net/RD_landing_page/tabTestsBanner.jpg"
            />
            <source
              media="(min-width: 320px)"
              srcSet="https://du03hetco8xdw.cloudfront.net/RD_landing_page/mobileTestsBanner.jpg"
            />
            <img
              src="https://du03hetco8xdw.cloudfront.net/RD_landing_page/webTestsBanner.jpg"
              alt="Tests Banner"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                maxWidth: "100%",
                objectFit: "cover",
                borderRadius: "20px",
              }}
            />
          </picture>
        </Box> */}
        <Box
          sx={{
            position: "relative",
            overflow: "hidden",
            borderRadius: "20px",
            padding: "24px",
            marginBottom: "32px",
            backgroundImage: `url("${randomBgImage}")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <Box
            sx={{
              position: "relative",
              zIndex: 4,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "20px",
              "@media (max-width: 768px)": {
                flexDirection: "column",
                textAlign: "center"
              }
            }}
          >
            <Box sx={{ position: "relative", minHeight: "80px", overflow: "hidden" }}>
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: "28px",
                  fontWeight: 700,
                  marginBottom: "8px",
                  letterSpacing: "-0.5px",
                  lineHeight: 1.2,
                  textShadow:
                    "2px 2px 4px rgba(0, 0, 0, 0.7), 0 0 20px rgba(0, 0, 0, 0.3)",
                  transition: "opacity 0.5s ease-in-out, transform 0.3s ease-in-out",
                  animation: "fadeIn 0.8s ease-in-out"
                }}
              >
                {bannerData.headText || headline}
              </Typography>
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: "16px",
                  fontWeight: 500,
                  opacity: 0.95,
                  lineHeight: 1.4,
                  textShadow:
                    "1px 1px 3px rgba(0, 0, 0, 0.6), 0 0 15px rgba(0, 0, 0, 0.2)",
                  transition: "opacity 0.5s ease-in-out, transform 0.3s ease-in-out",
                  animation: "fadeIn 0.8s ease-in-out 0.2s both"
                }}
              >
                {bannerData.subText || subText}
              </Typography>
            </Box>
            <Button
              onClick={handleCEE}
              sx={{
                backgroundColor: "#ffffff",
                color: "#06B6D4",
                border: "3px solid #ffffff",
                padding: "14px 28px",
                borderRadius: "12px",
                fontWeight: 700,
                fontSize: "16px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                boxShadow:
                  "0 6px 20px rgba(0, 0, 0, 0.3), 0 0 0 2px rgba(255, 255, 255, 0.5)",
                "&:hover": {
                  backgroundColor: "#f0f0f0",
                  transform: "translateY(-3px)",
                  boxShadow:
                    "0 8px 25px rgba(0, 0, 0, 0.4), 0 0 0 3px rgba(255, 255, 255, 0.7)"
                }
              }}
            >
              Take the CEE
            </Button>
          </Box>
        </Box>
        <Box>
          <Typography
            sx={{
              fontWeight: "400",
              color: Color.neutralMidGrey,
              fontSize: "16px",
              letterSpacing: 0.5,
            }}
          >
            Select the category of tests you would like to take
          </Typography>
        </Box>
        <Box>
          {testTypes.length > 0 ? (
            <Box
              sx={{
                display: "flex",
                boxShadow: " 0px 0px 15px 0px rgba(0, 0, 0, 0.08)",
                gap: "32px",
                padding: "8px",
                borderRadius: "15px",
                alignItems: "center",
                "@media (max-width: 600px)": {
                  overflowX: "auto",
                  "&::-webkit-scrollbar": {
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "4px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#888",
                    borderRadius: "4px",
                    "&:hover": {
                      background: "#555",
                    },
                  },
                },
              }}
            >
              {testTypes.map((test, test_index) => (
                <Box
                  sx={{
                    width: "100%",
                    padding: "10px",
                    backgroundColor: test.selected ? Color.primary4 : "#fff",
                    borderRadius: "10px",
                    "&:hover": { cursor: "pointer" },
                    "@media (max-width: 600px)": {
                      minWidth: "150px",
                    },
                  }}
                  onClick={e => handleTestTypeSelection(test_index)}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      textAlign: "center",
                      fontWeight: test.selected ? "700" : "400",
                      color: test.selected ? "white" : Color.neutralMidGrey,
                      letterSpacing: 0.4,
                    }}
                  >
                    {test.test_type_name}
                  </Typography>
                </Box>
              ))}
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                boxShadow: " 0px 0px 15px 0px rgba(0, 0, 0, 0.08)",
                gap: "48px",
                padding: "8px",
                borderRadius: "15px",
              }}
            >
              <Skeleton
                variant="rectangular"
                width={200}
                height={50}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />
              <Skeleton
                variant="rectangular"
                width={200}
                height={50}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />
              <Skeleton
                variant="rectangular"
                width={200}
                height={50}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />
              <Skeleton
                variant="rectangular"
                width={200}
                height={50}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />
            </Box>
          )}
        </Box>

        {testTypes.length > 0 &&
          testTypes.find(item => item.selected).test_sections !== null ? (
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box>
              {selectedRolePrepardness === "Role" ? (
                <Autocomplete
                  value={selectedRoles}
                  onChange={(event, newValue) => {
                    if (![null, undefined].includes(newValue)) {
                      setSelectedRoles(newValue);
                    }
                  }}
                  autoComplete
                  getOptionLabel={options => options.section_name}
                  inputValue={inputValue}
                  onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                  }}
                  options={testTypes.find(item => item.selected).test_sections}
                  sx={{ width: 300 }}
                  autoHighlight
                  clearIcon={null}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label={
                        testTypes
                          .find(item => item.selected)
                          .test_category.charAt(0)
                          .toUpperCase() +
                        testTypes
                          .find(item => item.selected)
                          .test_category.slice(1)
                      }
                    />
                  )}
                />
              ) : (
                <Select
                  value={selectedRoles}
                  sx={{ width: "300px" }}
                  onChange={e => handleRoleSelect(e)}
                >
                  {allSpecializations.map(item => (
                    <MenuItem key={item} value={item}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </Box>
          </Box>
        ) : (
          <></>
        )}

        {!testLoader ? (
          <>
            {tests.length > 0 || onGoingTest.length > 0 ? (
              <Box>
                {/* {completedTest.length > 0 && (
                  <Typography sx={{ fontSize: "26px", marginBlock: "1.5rem" }}>
                    Unattempted Test
                  </Typography>
                )} */}
                <Grid container rowGap={3} columnSpacing={6}>
                  {onGoingTest.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "16px",
                          padding: "16px",
                          boxShadow: " 0px 10px 23.8px 0px rgba(0, 0, 0, 0.10)",
                          borderRadius: "20px",
                          height: "100%",
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box>
                          <Typography sx={{ fontSize: "24px" }}>
                            {item.test_name}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "16px",
                              color: "#8B8B8B",
                              letterSpacing: 0.5,
                              pt: 1.5,
                              pb: 0.5,
                            }}
                          >
                            Questions: {item.total_no_questions}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "16px",
                              color: "#8B8B8B",
                              letterSpacing: 0.5,
                              pb: 1.5,
                            }}
                          >
                            Duration: {item.duration} mins
                          </Typography>
                        </Box>
                        <Box>
                          <Box sx={{ display: "flex", alignItems: "center", gap: "20px", mt: 0.5 }}>
                            <Typography sx={{ fontSize: "16px", color: Color.accent, fontWeight: "600" }}>⏳ Resume Test</Typography>
                          </Box>
                          <button
                            style={{
                              border: "1px solid #1c8ea8",
                              backgroundColor: Color.primary2,
                              width: "100%",
                              borderRadius: "10px",
                              padding: "10px",
                            }}
                            onClick={() => handleTestSelection(item, "onGoing")}
                          >
                            Resume Test
                          </button>
                          <div className="tooltip-wrapper" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", marginTop: "5px" }}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              style={{
                                height: "0.875rem",
                                width: "0.875rem",
                                color: "#9ca3af",
                              }}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                            <span
                              style={{
                                fontSize: "14px",
                                letterSpacing: 0.4,
                                color: Color.neutralMidGrey,
                                // textDecorationLine: "underline",
                                // textDecorationStyle: "dashed",
                              }}
                            >
                              How does it work?
                            </span>
                            <span className="tooltip-content-skills w-72">
                              This test is 100% proctored following international standards via live webcam & audio analysis. Moving away, multiple faces, or external voices may auto-close your test. No restarts. Auto-submits after time’s up. After submission, get your score & percentile to assess your skills.
                            </span>
                          </div>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                  {completedTest.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "16px",
                          padding: "16px",
                          boxShadow: " 0px 10px 23.8px 0px rgba(0, 0, 0, 0.10)",
                          borderRadius: "20px",
                          height: "100%",
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "1rem",
                          }}
                        >
                          <Typography sx={{ fontSize: "24px" }}>
                            {item.test_name}
                          </Typography>
                          <Typography
                            sx={{ letterSpacing: 0.4, fontSize: "12px", color: "#08AB3F", backgroundColor: "rgba(8, 171, 63, 0.1)", borderRadius: 10, width: "fit-content", p: 0.5 }}
                          >
                            <DoneOutlinedIcon sx={{ mr: 0.5, fontSize: "14px" }} />
                            ATTEMPTED
                          </Typography>
                        </Box>
                        <Box>
                          <Box
                            sx={{
                              display: "flex",
                              gap: "30px",
                              pb: 1.5
                            }}
                          >
                            <Box>
                              <Typography
                                sx={{ fontSize: "16px", color: "#8B8B8B" }}
                              >
                                Score:
                              </Typography>
                              <Typography
                                sx={{ fontSize: "16px", color: Color.primary1, fontWeight: "600" }}
                              >
                                {item.score}/{item.mxm_marks}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography
                                sx={{ fontSize: "16px", color: "#8B8B8B" }}
                              >
                                Percentile:
                              </Typography>
                              {
                                item.percentile === 100 ? <Typography
                                  sx={{ fontSize: "16px", color: Color.primary1, fontWeight: "600" }}
                                >
                                  Topper among {item.no_of_test_given} learners
                                </Typography> : <Typography
                                  sx={{ fontSize: "16px", color: Color.primary1, fontWeight: "600" }}
                                >
                                  Top {(100 - item.percentile).toFixed(2)}% of {item.no_of_test_given} learners
                                </Typography>
                              }
                            </Box>
                          </Box>
                          <button
                            style={{
                              border: "1px solid #1c8ea8",
                              width: "100%",
                              borderRadius: "10px",
                              padding: "10px",
                              color: Color.primary1
                            }}
                            onClick={() => {
                              navigate("/Endtest", {
                                state: {
                                  responseData: {
                                    mxm_marks: item.mxm_marks,
                                    score: item.score,
                                  },
                                  test_id: item.test_id,
                                  testType: testTypes.find(
                                    t => t.selected === true
                                  ),
                                },
                              });
                            }}
                          >
                            View Details
                          </button>
                          <div className="tooltip-wrapper" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", marginTop: "5px" }}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              style={{
                                height: "0.875rem",
                                width: "0.875rem",
                                color: "#9ca3af",
                              }}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                            <span
                              style={{
                                fontSize: "14px",
                                letterSpacing: 0.4,
                                color: Color.neutralMidGrey,
                                // textDecorationLine: "underline",
                                // textDecorationStyle: "dashed",
                              }}
                            >
                              How does it work?
                            </span>
                            <span className="tooltip-content-skills w-72">
                              This test is 100% proctored following international standards via live webcam & audio analysis. Moving away, multiple faces, or external voices may auto-close your test. No restarts. Auto-submits after time’s up. After submission, get your score & percentile to assess your skills.
                            </span>
                          </div>
                        </Box>

                      </Box>
                    </Grid>
                  ))}
                  {tests.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "16px",
                          padding: "16px",
                          boxShadow: " 0px 10px 23.8px 0px rgba(0, 0, 0, 0.10)",
                          borderRadius: "20px",
                          height: "100%",
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box>
                          <Typography sx={{ fontSize: "24px" }}>
                            {item.test_name}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "16px",
                              color: "#8B8B8B",
                              letterSpacing: 0.5,
                              pt: 1.5,
                              pb: 0.5,
                            }}
                          >
                            Questions: {item.total_no_questions}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "16px",
                              color: "#8B8B8B",
                              letterSpacing: 0.5,
                              pb: 1,
                            }}
                          >
                            Duration: {item.duration} mins
                          </Typography>
                        </Box>
                        <Box>
                          {item.no_of_test_given >= 100 && item.no_of_test_given < 1000 && (
                            <Typography
                              sx={{
                                color: Color.accent,
                                fontSize: "16px",
                                fontWeight: "400",
                                pb: 1.5,
                                letterSpacing: 0.5,
                              }}
                            >
                              {" "}
                              🔥 Taken by{" "}
                              <span style={{ fontWeight: "600" }}>
                                {formatTestTakersRange(item.no_of_test_given)} learners
                              </span>
                            </Typography>
                          )}
                          {item.no_of_test_given >= 1000 && <Typography
                            sx={{
                              color: Color.accent,
                              fontSize: "16px",
                              fontWeight: "400",
                              pb: 1.5,
                              letterSpacing: 0.5,
                            }}
                          >
                            🔥 Taken by{" "}
                            <span style={{ fontWeight: "600" }}>
                              {item.no_of_test_given} learners
                            </span>
                          </Typography>
                          }
                          {item.no_of_test_given < 100 && (
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "6px",
                                alignItems: "center",
                                pb: 1.5
                              }}
                            >
                              <Typography
                                sx={{
                                  backgroundColor: Color.primary1,
                                  color: "white",
                                  borderRadius: 1,
                                  fontSize: "10px",
                                  letterSpacing: 0.5,
                                  textAlign: "center",
                                  px: 0.5,
                                  py: 0.2,
                                  fontWeight: "600",
                                }}
                              >
                                NEW
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "16px",
                                  color: Color.primary1,
                                  letterSpacing: 0.5,
                                }}
                              >
                                Recently added
                              </Typography>
                            </Box>
                          )}
                          <button
                            style={{
                              border: "1px solid #1c8ea8",
                              backgroundColor: Color.primary2,
                              width: "100%",
                              borderRadius: "10px",
                              padding: "10px",
                            }}
                            onClick={() =>
                              handleTestSelection(item, "unAttempted")
                            }
                          >
                            Start Test
                          </button>
                          <div className="tooltip-wrapper" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", marginTop: "5px" }}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              style={{
                                height: "0.875rem",
                                width: "0.875rem",
                                color: "#9ca3af",
                              }}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                            <span
                              style={{
                                fontSize: "14px",
                                letterSpacing: 0.4,
                                color: Color.neutralMidGrey,
                                // textDecorationLine: "underline",
                                // textDecorationStyle: "dashed",
                              }}
                            >
                              How does it work?
                            </span>
                            <span className="tooltip-content-skills w-72">
                              This test is 100% proctored following international standards via live webcam & audio analysis. Moving away, multiple faces, or external voices may auto-close your test. No restarts. Auto-submits after time’s up. After submission, get your score & percentile to assess your skills.
                            </span>
                          </div>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            ) : (
              <></>
            )}
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              paddingLeft: { xs: "none", md: "100px" },
              gap: "50px",
              marginTop: "50px",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                padding: "24px",
                borderRadius: "20px",
                boxShadow: " 0px 10px 23.8px 0px rgba(0, 0, 0, 0.10)",
              }}
            >
              <Skeleton
                variant="rectangular"
                width={120}
                height={25}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />
              <Skeleton
                variant="rectangular"
                width={120}
                height={20}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />
              <Skeleton
                variant="rectangular"
                width={120}
                height={20}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />

              <Skeleton
                variant="rectangular"
                width={210}
                height={30}
                sx={{ borderRadius: "8px" }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                padding: "24px",
                borderRadius: "20px",
                boxShadow: " 0px 10px 23.8px 0px rgba(0, 0, 0, 0.10)",
              }}
            >
              <Skeleton
                variant="rectangular"
                width={120}
                height={25}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />
              <Skeleton
                variant="rectangular"
                width={120}
                height={20}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />
              <Skeleton
                variant="rectangular"
                width={120}
                height={20}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />

              <Skeleton
                variant="rectangular"
                width={210}
                height={30}
                sx={{ borderRadius: "8px" }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                padding: "24px",
                borderRadius: "20px",
                boxShadow: " 0px 10px 23.8px 0px rgba(0, 0, 0, 0.10)",
              }}
            >
              <Skeleton
                variant="rectangular"
                width={120}
                height={25}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />
              <Skeleton
                variant="rectangular"
                width={120}
                height={20}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />
              <Skeleton
                variant="rectangular"
                width={120}
                height={20}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />

              <Skeleton
                variant="rectangular"
                width={210}
                height={30}
                sx={{ borderRadius: "8px" }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                padding: "24px",
                borderRadius: "20px",
                boxShadow: " 0px 10px 23.8px 0px rgba(0, 0, 0, 0.10)",
              }}
            >
              <Skeleton
                variant="rectangular"
                width={120}
                height={25}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />
              <Skeleton
                variant="rectangular"
                width={120}
                height={20}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />
              <Skeleton
                variant="rectangular"
                width={120}
                height={20}
                animation="wave"
                sx={{ borderRadius: "8px" }}
              />

              <Skeleton
                variant="rectangular"
                width={210}
                height={30}
                sx={{ borderRadius: "8px" }}
              />
            </Box>
          </Box>
        )}

        <Modal
          open={modal}
          onClose={() => {
            setModal(false);
            setButtonDisabled(true);
          }}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              background: "#fff",
              padding: "20px",
              borderRadius: "30px",
              gap: "16px",
            }}
          >
            {modalIndex === 0 ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <img
                  src="https://du03hetco8xdw.cloudfront.net/Assessment_test/allowAccess.svg"
                  style={{}}
                />
                <Typography
                  sx={{
                    fontSize: "32px",
                    color: "#1c8ea8",
                    textAlign: "center",
                  }}
                >
                  Allow Access
                </Typography>
                <Typography sx={{ fontSize: "16px", textAlign: "center" }}>
                  It is necessary to allow access to your camera
                  to start the test.
                  <br /> Click below to provide access.
                </Typography>
                {cameraError && (
                  <Typography
                    sx={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "center",
                      mt: 2,
                    }}
                  >
                    {cameraError}
                  </Typography>
                )}
                <Button
                  variant="contained"
                  onClick={handleCameraAccess}
                  sx={{
                    marginTop: "20px",
                    backgroundColor: "#1c8ea8",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "#157a91",
                    },
                  }}
                >
                  Enable Camera & Microphone
                </Button>
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Webcam
                  ref={webcamRef}
                  style={{ width: "800px", height: "400px", padding: "20px" }}
                />
                <Typography
                  sx={{
                    fontSize: "32px",
                    color: "#1c8ea8",
                    textAlign: "center",
                  }}
                >
                  Face Recognition
                </Typography>
                <Typography
                  sx={{
                    fontSize: "16px",
                    textAlign: "center",
                    marginBlock: "8px",
                  }}
                >
                  Kindly center your face in the frame to be accepted
                </Typography>
                <Typography
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "center",
                  }}
                >
                  {faceError}
                </Typography>

                <button
                  disabled={buttonDisabled}
                  style={{
                    background: buttonDisabled
                      ? "#8B8B8B"
                      : "linear-gradient(133deg, #2AA8C4 16.39%, #38C1DF 100%)",
                    padding: "12px 50px",
                    fontSize: "16px",
                    borderRadius: "10px",
                    color: "#fff",
                  }}
                  onClick={() =>
                    navigate("/Instructions", {
                      state: {
                        selectedTest: selectedTest,
                        testType: testTypes.find(t => t.selected === true),
                      },
                    })
                  }
                >
                  View Instructions
                </button>
              </Box>
            )}
          </Box>
        </Modal>
      </div>
    </Box>
  );
}

export default AssessmentTest;
